import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { Spinner } from '../../../../../components/Spinner';
import { useEnv } from '../../../../../context/env-context';
import { useAuth } from '../../../../../hooks/useAuth';
import { makeRequest } from '../../../../../utils/makeRequest';
import { toast } from 'react-toastify';

function ConsumerGhostedByWidget({ consumerGhostingConsumers, setConsumer }) {
  const { apiOriginConsumer } = useEnv();
  const { getAccessTokenSilently } = useAuth();

  const [spinner, setSpinner] = useState(false);

  const unghostConsumer = async ghostingConsumerId => {
    if (window.confirm('Are you sure?')) {
      setSpinner(true);

      try {
        const token = await getAccessTokenSilently();

        if (!token) {
          return;
        }

        const config = {
          token,
          url: `${apiOriginConsumer}/unghost`,
          method: 'POST',
          data: JSON.stringify({ ghostingConsumerId }),
        };

        await makeRequest(config);

        setConsumer(prev => ({
          ...prev,
          ghostingConsumers: prev.ghostingConsumers.filter(
            x => x.consumerId !== ghostingConsumerId,
          ),
        }));
      } catch (error) {
        toast.error(error.message);
      } finally {
        setSpinner(false);
      }
    }
  };

  return (
    <div className="bo-error-border-container p-0 rounded w-100">
      <Spinner visible={spinner} size={36} borderRadius={5}>
        <div className="p-2">
          <p className="bo-consumer-text-bold">Ghosted by:</p>
          <div className="ms-2 mt-2 d-flex flex-column gap-1">
            {consumerGhostingConsumers.map(x => (
              <div key={x.consumerId} className="d-flex justify-content-between">
                <p className="bo-consumer-text">{`${x.firstName} ${x.lastName}`}</p>
                <Button
                  className="bo-common-inline-button"
                  onClick={() => unghostConsumer(x.consumerId)}
                >
                  Unghost
                </Button>
              </div>
            ))}
          </div>
        </div>
      </Spinner>
    </div>
  );
}

export default ConsumerGhostedByWidget;
